import React from "react";
import classNames from "classnames";
import { HashLink as Link } from "react-router-hash-link";

const FooterNav = ({ className, ...props }) => {
  const classes = classNames("footer-nav", className);

  return (
    <nav {...props} className={classes}>
      <ul className="list-reset">
        <li>
          <Link to="/#contact">Contact</Link>
        </li>
        <li>
          <Link to="/#about">About us</Link>
        </li>
        <li>
          <Link to="/#work">Our work</Link>
        </li>
        <li>
          <Link to="/terms">Terms</Link>
        </li>
        <li>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </li>
      </ul>
    </nav>
  );
};

export default FooterNav;
